import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import LockPDFImageListScreen from "./LockPDFImageListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function LockPDFMin() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Lock PDF documents" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/lock_pdf", title: "PDF Locker" },
    data2: { link: "/lock_pdf", title: "Password Protect PDF Documents" },
    data3: { link: "/lock_pdf", title: "Encrypt PDF Documents" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Lock PDF files online instantly. Add password protection, secure sensitive documents, and protect PDFs easily with our fast PDF lock tool."
      ></meta>
      <meta
        name="keywords"
        content="lock pdf, lock pdf online, pdf lock, password protect pdf, secure pdf, encrypt pdf, protect pdf file, add password to pdf, pdf security, pdf protection tool, lock pdf free, secure pdf online, pdf encryption tool, protect pdf documents, pdf locker"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <LockPDFImageListScreen title={title}></LockPDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Lock PDF is a secure and user-friendly PDF locker website designed to lock PDF files and protect sensitive documents completely offline, making it an ideal solution for users who value privacy and data security. Unlike online PDF locking tools that require uploading files to external servers, this offline PDF locker works directly on your device, ensuring that your PDF files never leave your system and remain fully confidential. With PDF Locker, users can easily lock PDF documents, password protect PDF files, apply strong PDF encryption, and prevent unauthorized access, editing, copying, or printing of important documents without needing an internet connection. The website offers fast performance, preserves original document quality, and features a simple, intuitive interface that allows anyone to lock PDF files in just a few clicks. This offline PDF protection tool is perfect for securing personal files, business documents, legal papers, financial records, academic materials, and confidential reports while maintaining complete control over data privacy. By eliminating cloud dependency and online risks, PDF Locker provides a reliable PDF security website for users seeking lock PDF solutions, offline PDF encryption, secure PDF documents, and password-protected PDF files with maximum safety, convenience, and trust." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Lock",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Lock PDF"
            why_use={[
              {
                title: "Complete Data Privacy",
                description:
                  "Our lock PDF offline tool ensures that your files never leave your device, providing maximum data privacy and security. Unlike online PDF locker websites, offline PDF locking tools do not upload documents to external servers, reducing the risk of data breaches and unauthorized access.",
              },
              {
                title: "Works Without Internet Connection",
                description:
                  "Our offline PDF locker works even without internet access, making it ideal for users in low-connectivity areas or those who prefer secure PDF protection without relying on cloud services. You can lock PDF files anytime, anywhere.",
              },
              {
                title: "Enhanced Security with Strong Encryption",
                description:
                  "Offline lock PDF tools use advanced PDF encryption to password protect PDF files, ensuring only authorized users can open, edit, copy, or print the document. This makes it a reliable solution for securing confidential PDF documents.",
              },

              {
                title: "Faster PDF Locking Process",
                description:
                  "Since files are processed locally, an offline PDF locking tool offers faster performance compared to online tools. You can instantly lock PDF documents without upload or download delays.",
              },
              {
                title: "No File Size Limits",
                description:
                  "Other online PDF lockers have file size restrictions, while offline PDF lock tools allow you to lock large PDF files easily. This makes them perfect for business reports, legal documents, and high-resolution PDFs.",
              },
              {
                title: "No Account or Registration Required",
                description:
                  "This offline PDF locker does not require sign-ups or personal information. You can lock PDF files without creating an account, ensuring a secure and hassle-free experience.",
              },
              {
                title: "Ideal for Sensitive and Confidential Documents",
                description:
                  "Lock PDF offline tools are perfect for securing legal files, financial statements, medical records, academic documents, and corporate data, providing trusted offline PDF protection.",
              },
              {
                title: "Prevents Unauthorized Editing and Printing",
                description:
                  "With a lock PDF tool, you can restrict editing, copying, and printing of PDF files, ensuring complete document control and protection from misuse.",
              },
              {
                title: "Cross-Platform Compatibility",
                description:
                  "Our offline PDF locker tools work across multiple operating systems and browsers, allowing users to securely lock PDF files on different devices without internet dependency.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I lock a PDF file online for free?",
                description:
                  "You can lock a PDF by uploading or selecting your PDF file, entering a password, and applying password protection. Download the protected PDF when the process is complete."
              },
              {
                title: "What is a PDF locker?",
                description:
                  "A PDF locker is a tool that protects PDF documents with a password. It helps prevent unauthorized users from opening your file and viewing its contents."
              },
              {
                title: "Can I lock a PDF offline?",
                description:
                  "Yes, if the PDF locking tool supports offline processing. A locally processed PDF can be password-protected on your device without requiring an internet connection after the tool has loaded."
              },
              {
                title: "Does ShivaPDF lock PDF files locally?",
                description:
                  "Local PDF processing means your document is processed directly in your browser instead of being uploaded to a server. Check that the Lock PDF tool on ShivaPDF.com supports local processing before using it for sensitive documents."
              },
              {
                title: "Is it safe to password-protect a PDF online?",
                description:
                  "Password-protecting a PDF can help keep its contents private. For sensitive documents, choose a trusted tool that clearly explains how files are processed and whether they are uploaded to a server."
              },
              {
                title: "Does locking a PDF upload my file to a server?",
                description:
                  "Whether a PDF is uploaded depends on how the tool is implemented. If the tool processes files entirely in your browser, your PDF can remain on your device during the locking process."
              },
              {
                title: "How do I add a password to a PDF?",
                description:
                  "Open a PDF password protection tool, select your document, enter a strong password, and apply the protection. Save the resulting PDF and keep your password somewhere secure."
              },
              {
                title: "Can I protect a PDF with a strong password?",
                description:
                  "Yes. Use a long, unique password that combines letters, numbers, and symbols where supported. Avoid easily guessed information such as your name, birthday, or common words."
              },
              {
                title: "Can I lock a PDF without installing software?",
                description:
                  "A browser-based PDF locker lets you protect documents without installing a separate desktop application, provided the tool supports your browser and device."
              },
              {
                title: "Do I need to create an account to lock a PDF?",
                description:
                  "Account requirements depend on the service. If the Lock PDF tool is available without registration, you can use it directly without creating an account."
              },
              {
                title: "Can I lock a PDF on my mobile phone?",
                description:
                  "Yes, you can use a mobile-compatible PDF locking tool in a supported browser on an Android phone, iPhone, or tablet. The available features may vary by device and browser."
              },
              {
                title: "Can I lock a PDF on a Mac or Windows computer?",
                description:
                  "You can password-protect PDF files on Mac and Windows using a compatible browser-based tool or desktop application. Check the tool's requirements before processing your document."
              },
              {
                title: "Can I lock a large PDF file?",
                description:
                  "Large PDFs may require more memory and processing time. The maximum supported file size depends on the tool, browser, and available device resources."
              },
              {
                title: "Will locking a PDF change its content?",
                description:
                  "Password protection is intended to secure access to a PDF rather than edit its text or images. However, always review the protected file after processing to confirm it opens and displays correctly."
              },
              {
                title: "Does locking a PDF reduce its quality?",
                description:
                  "Applying password protection should not require reducing the quality of the PDF's text or images. The result depends on how the tool creates the protected document."
              },
              {
                title: "Can I password-protect a scanned PDF?",
                description:
                  "Yes, scanned documents saved as PDFs can generally be password-protected just like other PDF files. The password protects access to the document without requiring the scanned pages to be converted into editable text."
              },
              {
                title: "Can I lock a PDF that already has a password?",
                description:
                  "If a PDF is already password-protected, you may need to enter its existing password before applying new protection. The exact steps depend on the document's current security settings and the tool's capabilities."
              },
              {
                title: "What should I do if I forget my PDF password?",
                description:
                  "Keep a secure record of your PDF password because recovering a forgotten password may not be possible. If you still have access to the document, check whether your PDF software offers a supported way to change its security settings."
              },
              {
                title: "Can I remove a password from a PDF?",
                description:
                  "A PDF password removal tool may let you remove protection from a document when you have the required password and permission to modify it. The available options depend on the PDF's security settings."
              },
              {
                title: "Does password protection prevent PDF editing and printing?",
                description:
                  "PDF security settings may restrict actions such as editing, copying, or printing. These permissions are different from a password required to open the file, and their enforcement depends on the PDF reader."
              },
              {
                title: "Why can't I open my locked PDF?",
                description:
                  "Make sure you are entering the correct password and using a PDF reader that supports password-protected files. If the file still does not open, try downloading it again or checking whether the original file was damaged."
              },
              {
                title: "Is the Lock PDF tool on ShivaPDF free to use?",
                description:
                  "Check the Lock PDF page on ShivaPDF.com for the current usage limits and pricing. Availability, file-size limits, and other restrictions may depend on the version of the tool."
              }
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1623109999}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default LockPDFMin;
